import styled, {css} from "styled-components";
import { Button, Select, Grid, Tabs, Accordion, TableContainer, AccordionSummary, TableCell, TableRow } from "@mui/material";
import { Box, styled as MuiStyled } from "@mui/system";
import { Chip } from "@mui/material";
import { deviceSpec } from "breakpoints";


export const IncidentDetailsRoundButton = {
  color: "white",
  borderColor: "white",
  borderRadius: "25px",
  fontSize: "12px",
  height: "30px",
};

export const sectionBorder = {
  borderColor: "#808080",
  borderStyle: "solid",
  borderWidth: "0 0 0.5px 0",
};

export const hidden = css`
  display: none;
`;

export const IncidentDetailsContainer = styled(Accordion)`
  width: 100%;

  #panel1-header {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  #panel1-header:focus {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  > div:not(:last-child) {
    // border-bottom: 1px solid #808080;
  }

  th {
    word-break: break-word;
  }
`

export const AccordionSummaryRow = styled('div')`
  display: flex;

  span {
    border-bottom: 1px solid rgba(81, 81, 81, 1);
  text-align: left;
  padding: 16px;
  }

  span:nth-child(1) {
    flex: 9;
  }

  span:nth-child(2) {
    flex: 3;
  }
`

export const IOCRowStyle = styled(TableRow)`
  td {
    min-width: max-content;
    word-break: initial;
  }
`

export const IOCMoreRow = styled(TableRow)`
  span {
    color: ${({theme}) => theme.colors.textColor} !important;
  }

  td:nth-child(even) {
    flex-grow: 3 !important;
    max-width: 80%;
    word-wrap: anywhere;
  }

  td:nth-child(odd) {
    flex-grow: 1 !important;
    max-width: 20%;
  }
`

export const IOCMoreCell = styled(TableCell)`
  border-bottom: none !important;
`

export const IncidentSummaryContainer = styled(Grid)`
  position: relative;
  padding: 32px;
  color: ${({theme}) => theme.colors.textColor};
  height: initial;
  align-content: baseline;
  background-color: ${({theme}) => theme.colors.historyBg};

  &>div {
    padding: 16px 0px;
  }

  @media ${deviceSpec.isMobile} {
    &>div, > span {
      word-break: break-word;
      width: 100%;
      padding: 16px 0px;
    }
  }

  .prism-code {
    p, span, h1, h2, h3, h4, h5, td, a, button, code {
      word-wrap: break-word;
      word-break: break-word;
      font-family: neulis-sans, sans-serif;
      color: white;
      font-size: 100%;
    }
  }

  code {
    color: inherit;
  }

  a {
    color: #1976d2;
  }
`;

export const IncidentSummaryHeader = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline; 

  span: nth-child(0) {
    flex: 8;
  }

  span: nth-child(1) {
    flex: 2;
  }
`

export const leftAndRightAlignedContainer = {
  ".MuiGrid-item:first-of-type": {
    width: "50%",
  },
  ".MuiGrid-item:last-of-type": {
    width: "50%",
    textAlign: "right",
  },
};

export const ActionsContainer = MuiStyled(Grid)({
  ...leftAndRightAlignedContainer,
});

export const UserDetailsGrid = MuiStyled(Grid)`
  height: 134px;
  div.MuiGrid-item {
    padding: 24px 0;
    width: 33.3333%;x
    height: 100%;
    border-color: #808080;
    border-width: 1px;
    border-style: solid;
    padding: 12px;
  }

  span {
    display: block;
    height: 24px;
    overflow-wrap: break-word;
  }

  span:nth-child(odd) {
    font-weight: 600;
  }
`;


export const TabContainer = styled(Tabs)`
  .MuiTabs-flexContainer {
    display: flex;

    .MuiButtonBase-root {
      flex-grow: 1;
    }
  }
`

export const FeedbackStyle = styled('div')`
  position: absolute;
  right: 0;
  display: flex;
`

export const TagsContainer = MuiStyled(Grid)({
  ...sectionBorder,
  ...leftAndRightAlignedContainer,

  display: "flex",
  flexDirection: "column",

  ".title": {
    height: "32px",
    fontSize: "20px",
  },
});

export const TextContainer = MuiStyled(Grid)`
  span: {
    display: block;
  }
  
  span:first-of-type {
    height: 32px;
    margin-bottom: 8px;
    font-weight: 500
  }

  .key-names {
    color: primary_lighter;
    opacity: 0.75
  }

  @media ${deviceSpec.isMobile} {
    .MuiButtonBase-root {
      height: min-content;
      padding: 8px !important;
      word-break: break-word;
    }
  }

  margin-top: 0;
  margin-left: 0
`;


export const MarkdownContainer = styled.div`
  h1, h2, h3 {
    font-size: ${({ theme }) => theme.font.large} !important;
  }

  p, pre, li {
    font-size: ${({ theme }) => theme.font.medium};
    margin-top: ${({ theme }) => theme.font.small};
    border: none;
  }

  code {
    display: block;
    font-size: ${({ theme }) => theme.font.medium};
    margin-left: 2em;
  }
  
  li, p {
    display: flex;
    flex-wrap: wrap;
    // align-items: center;
    margin: 0.25em;

    code {
      margin: 0 0.5em;
    }
  }
`;

export const CommentsContainer = MuiStyled(Grid)({
  ...leftAndRightAlignedContainer,
  width: '100%',
  ".MuiInputBase-input": {
    fontSize: '14px'
  }
});

export const ActionButtonsContainer = MuiStyled(Grid)`
  ${sectionBorder}
`

export const FlywheelIocsContainer = MuiStyled('span')`
  th, td {
    width: auto;
    white-space: nowrap;
  }
`

export const CommentDetailContainer = MuiStyled('div')`
  display: flex;
  flex-direction: row;
  padding: 12px 0;
  transition: transform 330ms ease-in-out;
  
  span {
    verticalAlign: middle;
  }

  .MuiGrid-item {
    marginBottom: 8px;
  }
`;

export const CommentDetailContainerData = MuiStyled('div')`
  display: flex;
  flex-direction: column;
  span {
    margin-bottom: .5em;
  }
`;

export const CommentDetailHeader = MuiStyled(Grid)({
  ...leftAndRightAlignedContainer,
  ".MuiGrid-item": {
    height: "32px",
  },
  paddingBottom: "16px",
  span: {
    fontSize: "20px",
  },
});

export const ViewAllContainer = MuiStyled(Grid)({
  ...sectionBorder,
  width: "100%",
  "div.MuiGrid-item": {
    paddingTop: "12px",
    paddingBottom: "16px",
    textAlign: "end",
    width: "100%",
  },
});

export const RelatedIncidentsContainer = styled.div`
  ${sectionBorder}
  width: 100%;
  background-color: transparent;
  table {
    background-color: transparent;
    min-width: unset;
    border-width: 1px;
    border-style: solid;
    border-color: #5e5e5e;
    min-width: initial;
  }
  thead {
    background-color: #5e5e5e;
    min-width: auto;
    th {
      padding-left: 16px;
      font-size: 14px;
      font-weight: normal;
    }
  }
  tbody {
    min-width: auto;
  }
  tbody td span {
    // color: white;
  }
`;

export const IocsTableContainer = styled(TableContainer)`
  td, th {
    width: 20%;
  }
`;

export const PanelContainer = styled(Box)``;
export const TagChip = styled(Chip)``

/************ Components **********/

export const ClearIconContainer = styled(Button)`
  min-width: fit-content;
  svg {
    // color: white;
  }
  svg:hover {
    color: red;
  }
`

export const MoreDetailsButton = MuiStyled(Button)({
  ...IncidentDetailsRoundButton,
  "&:hover": {
    borderColor: "white",
  },
});


export const NewCommentButton = MuiStyled(Button)`
  border-radius: 4px;
  height: 30px;
  width: max-content;
  margin: 16px 0;
  align-self: start;

  &:hover: {
    borderColor: white;
  }
`;

export const NewCommentInputContainer = MuiStyled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 0.5em;
  
  .MuiInputBase-root {
    height: auto;
    box-shadow: inset 1.1px 1px 3.2px hsl(0deg 0% 0% / 0.47);
  }
`;

export const TagsButton = MuiStyled(Button)({
  ...IncidentDetailsRoundButton,
  borderRadius: "5px",
  marginBottom: "12px",
  fontSize: "14px",
  "&:hover": {
    borderColor: "white",
  },
});

export const ActivityTitleSpan = styled.span`
  font-size: 16px;
  display: block;
  margin-top: 16px;
`;

export const PrimaryButtonRounded = MuiStyled(Button)({
  color: "white",
  borderRadius: "10px",
  height: "24px",
});

export const PrimaryButtonRectangle = MuiStyled(Button)({
  color: "white",
  height: "32px",
  fontWeight: "500",
});

export const ActionsSelect = MuiStyled(Select)({
  height: "30px",
  borderRadius: "25px",
  borderColor: "white",
  borderStyle: "solid",
  borderWidth: "1px",
  padding: "0 10px",
  marginRight: "16px",
  "&:hover": {
    borderColor: "white",
  },
  fieldset: {
    border: "none",
  },
});

export const AccessButton = MuiStyled(Button)({
  color: "white",
  borderRadius: "20px",
  height: "30px",
});

export const CommentSpan = styled.span`
  font-size: 14px;
`;

interface DefaultUserCircleProps {
  backgroundColor: string;
}

export const DefaultUserCircle = styled.span<DefaultUserCircleProps>`
  height: 32px;
  width: 32px;
  background-color: ${props => props.backgroundColor};
  border-radius: 50%;
  display: inline-block;
  padding-top: 6px;
  text-align: center;
  margin-right: 16px;
`;


export const RelatedIncidentsTitle = styled.div`
  font-size: 20px;
  height: 32px;
  margin-bottom: 12px;
`;

export const AssignedToDropdown = MuiStyled(Select)({
  height: "30px",
  borderRadius: "25px",
  borderColor: "white",
  borderStyle: "solid",
  borderWidth: "1px",
  padding: "0 10px",
  fieldset: {
    border: "none",
  },
  "&:hover": {
    borderColor: "white",
  },
});

export const CloseBtnContainer = styled("span")`
  padding: 0 !important;

  .MuiButtonBase-root {
    position: absolute;
    z-index: 10000;
    right: 1em;
    top: 3em;
  }

  @media ${deviceSpec.isTablet} {
    top: 0.5em;
    right: 0.5em;
  }
`;


export const UserInputContainer = styled("span")`
  .MuiInputBase-root, .MuiButtonBase-root {
    height: auto;
  }

  .MuiIFormControl-root {
    label {
      top: 0 !important;
    }

    box-shadow: inset 1.1px 1px 3.2px hsl(0deg 0% 0% / 0.47)
  }
`;